export const getCinematicSource = (
  desktopSource: string,
  mobileSource: string
) => {
  if (typeof window !== 'undefined' && window.innerWidth <= 830) {
    return mobileSource;
  }
  return desktopSource;
};
